<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Atualizar Endereço' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <div *ngIf="endereco.id">
    <form
      [hidden]="semEstado"
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-select
                label="{{'País' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idPais"
                (ionChange)="mudarPais($event)"
              >
                <ion-select-option *ngFor="let pais of paises" [value]="pais.id"> {{pais.nome}} </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="!semEstado">
          <ion-col>
            <ion-item>
              <div class="d-flex">
                <label class="custom-label">{{'CEP' | translate}}</label>
                <input
                  class="native-input"
                  type="tel"
                  formControlName="cep"
                  (ionChange)="buscarCep()"
                  mask="00000-000"
                  placeholder="CEP"
                />
              </div>
              <ion-button fill="clear" slot="end" (click)="buscarCep()">
                <ion-icon slot="icon-only" name="search"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="semEstado">
          <ion-col>
            <ion-item>
              <ion-input
                labelPlacement="floating"
                label="{{'Caixa Postal' | translate}}"
                type="text"
                formControlName="caixaPostal"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item>
              <ion-select
                label="{{'Área/Região' | translate}}"
                label-placement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idRegiao"
              >
                <ion-select-option *ngFor="let reg of regiao" [value]="reg.id"> {{reg.nome}} </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Logradouro' | translate}}"
                labelPlacement="floating"
                formControlName="logradouro"
                type="text"
                placeholder="{{'Logradouro' | translate}}"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Número' | translate}}"
                labelPlacement="floating"
                formControlName="numero"
                type="text"
                placeholder="{{'Número' | translate}}"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Complemento' | translate}}"
                labelPlacement="floating"
                formControlName="complemento"
                type="text"
                placeholder="{{'Complemento' | translate}}"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row [hidden]="semEstado">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Bairro' | translate}}"
                labelPlacement="floating"
                formControlName="bairro"
                type="text"
                placeholder="{{'Bairro' | translate}}"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="!semEstado">
          <ion-col>
            <ion-item>
              <ion-select
                label="{{'Estado' | translate}}"
                label-placement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idEstado"
                (ionChange)="mudarEstado($event);"
              >
                <ion-select-option *ngFor="let estado of estados" [value]="estado.id">
                  {{estado.nome}}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="!semEstado">
          <ion-col>
            <ion-item>
              <ion-select
                label="{{'Cidade' | translate}}"
                label-placement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idCidade"
              >
                <ion-select-option *ngFor="let cidade of cidades" [value]="cidade.id">
                  {{cidade.nome}}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="semEstado">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Município' | translate}}"
                labelPlacement="floating"
                formControlName="cidadeNome"
                type="text"
                placeholder="{{'Município' | translate}}"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div class="down">
        <ion-button class="btn-success" expand="block" type="submit" [disabled]="!validations_form.valid">
          {{'Salvar' | translate}}
        </ion-button>
      </div>
    </form>

    <form
      [hidden]="!semEstado"
      class="sample-form validations-form"
      [formGroup]="validations_form_internacional"
      (ngSubmit)="onSubmitInternacional(validations_form_internacional.value)"
    >
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-select
                label="{{'País' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idPais"
                (ionChange)="mudarPais($event)"
              >
                <ion-select-option *ngFor="let pais of paises" [value]="pais.id"> {{pais.nome}} </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="!dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                #searchbar
                label="{{'Endereço' | translate}}"
                labelPlacement="floating"
                placeholder="{{'Endereço' | translate}}"
                formControlName="enderecoGoogle"
                type="search"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Caixa Postal' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Caixa Postal' | translate}}"
                formControlName="cep"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Logradouro' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Logradouro' | translate}}"
                formControlName="logradouro"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Número' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Número' | translate}}"
                formControlName="numero"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Complemento' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Complemento' | translate}}"
                formControlName="complemento"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Bairro' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Bairro' | translate}}"
                formControlName="bairro"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Estado' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Estado' | translate}}"
                formControlName="estadoNome"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="dubai">
          <ion-col>
            <ion-item class="switcher-item">
              <ion-input
                label="{{'Cidade' | translate}}"
                labelPlacement="floating"
                type="text"
                placeholder="{{'Cidade' | translate}}"
                formControlName="cidadeNome"
              ></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div class="down" *ngIf="!dubai">
        <ion-button
          class="btn-success"
          expand="block"
          type="submit"
          [disabled]="!validations_form_internacional.valid || !selecionado"
        >
          {{'Salvar' | translate}}
        </ion-button>
      </div>

      <div class="down" *ngIf="dubai">
        <ion-button class="btn-success" expand="block" type="submit"> {{'Salvar' | translate}} </ion-button>
      </div>
    </form>
  </div>
</ion-content>
